import { RadnaKnjizicaView } from './radna-knjizica/radna-knjizica-view';
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { LookupsRoutes } from "../lookups/routes";
import { KadComponent } from "./kad.component";
import { ModalSize, RefreshType, FormType, ColumnType, DefaultListType, RequestType, PrintType } from "yt-ng-framework";
import { Beneficirani } from "./beneficirani/beneficirani";
import { BeneficiraniComponent } from "./beneficirani/beneficirani.component";
import { BeneficiraniModalUpdateComponent } from "./beneficirani/beneficirani-modal-update.component";
import { VerskiPraznik } from "./verski-praznik/verski-praznik";
import { VerskiPraznikComponent } from "./verski-praznik/verski-praznik.component";
import { VerskiPraznikModalUpdateComponent } from "./verski-praznik/verski-praznik-modal-update.component";
import { RazlogPrestankaRo } from './razlog-prestanka-ro/razlog-prestanka-ro';
import { RazlogPrestankaRoComponent } from './razlog-prestanka-ro/razlog-prestanka-ro.component';
import { RazlogPrestankaRoModalUpdateComponent } from './razlog-prestanka-ro/razlog-prestanka-ro-modal-update.component';
import { OsnovZaGo } from './osnov-za-go/osnov-za-go';
import { OsnovZaGoComponent } from './osnov-za-go/osnov-za-go.component';
import { OsnovZaGoModalUpdateComponent } from './osnov-za-go/osnov-za-go-modal-update.component';
import { OsnovZaPlacenoOdsustvoComponent } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo.component';
import { OsnovZaPlacenoOdsustvo } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo';
import { OsnovZaPlacenoOdsustvoModalUpdateComponent } from './osnov-za-placeno-odsustvo/osnov-za-placeno-odsustvo-modal-update.component';
import { VeroispovestComponent } from './veroispovest/veroispovest.component';
import { Veroispovest } from './veroispovest/veroispovest';
import { VeroispovestModalUpdateComponent } from './veroispovest/veroispovest-modal-update.component';
import { JezikComponent } from './jezik/jezik.component';
import { Jezik } from './jezik/jezik';
import { JezikModalUpdateComponent } from './jezik/jezik-modal-update.component';
import { RadnaKnjizicaComponent } from "./radna-knjizica/radna-knjizica.component";
import { RadnaKnjizica } from "./radna-knjizica/radna-knjizica";
import { RadnaKnjizicaModalUpdateComponent } from './radna-knjizica/radna-knjizica-modal-update.component';
import { SistRadnihMestaComponent } from './sist-radnih-mesta/sist-radnih-mesta.component';
import { SistRadnihMesta } from './sist-radnih-mesta/sist-radnih-mesta';
import { SistRadnihMestaView } from './sist-radnih-mesta/sist-radnih-mesta-view';
import { OsobaTelefon } from '../lookups/osoba/osoba-telefon/osoba-telefon';
import { OsobaTelefonView } from '../lookups/osoba/osoba-telefon/osoba-telefon-view';
import { OsobaTelefonModalUpdateComponent } from '../lookups/osoba/osoba-telefon/osoba-telefon-modal-update.component';
import { OsobaEmail } from '../lookups/osoba/osoba-email/osoba-email';
import { OsobaEmailView } from '../lookups/osoba/osoba-email/osoba-email-view';
import { OsobaEmailModalUpdateComponent } from '../lookups/osoba/osoba-email/osoba-email-modal-update.component';
import { AngazovanjeRoComponent } from './angazovanje-ro/angazovanje-ro.component';
import { AngazovanjeRo } from './angazovanje-ro/angazovanje-ro';
import { AngazovanjeRoResenje } from './angazovanje-ro/angazovanje-ro-resenje';
import { AngazovanjeRoView } from './angazovanje-ro/angazovanje-ro-view';
import { AngazovanjeRoModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-modal-update.component';
import { OsobaZanimanje } from '../lookups/osoba/osoba-zanimanje/osoba-zanimanje';
import { OsobaZanimanjeView } from '../lookups/osoba/osoba-zanimanje/osoba-zanimanje-view';
import { OsobaZanimanjeModalUpdateComponent } from '../lookups/osoba/osoba-zanimanje/osoba-zanimanje-modal-update.component';
import { StatusRo } from './status-ro/status-ro';
import { StatusRoModalUpdateComponent } from './status-ro/status-ro-modal-update.component';
import { OsobaSrodstvo } from '../lookups/osoba/osoba-srodstvo/osoba-srodstvo';
import { OsobaSrodstvoView } from '../lookups/osoba/osoba-srodstvo/osoba-srodstvo-view';
import { OsobaSrodstvoModalUpdateComponent } from '../lookups/osoba/osoba-srodstvo/osoba-srodstvo-modal-update.component';
import { OsobaRadnaOprema } from '../lookups/osoba/osoba-radna-oprema/osoba-radna-oprema';
import { OsobaRadnaOpremaView } from '../lookups/osoba/osoba-radna-oprema/osoba-radna-oprema-view';
import { OsobaRadnaOpremaModalUpdateComponent } from '../lookups/osoba/osoba-radna-oprema/osoba-radna-oprema-modal-update.component';
import { RadnoVremeComponent } from './radno-vreme/radno-vreme.component';
import { RadnoVreme } from './radno-vreme/radno-vreme';
import { RadnoVremeModalUpdateComponent } from './radno-vreme/radno-vreme-modal-update.component';
import { OsobaZnaJezik } from '../lookups/osoba/osoba-zna-jezik/osoba-zna-jezik';
import { OsobaZnaJezikView } from '../lookups/osoba/osoba-zna-jezik/osoba-zna-jezik-view';
import { OsobaZnaJezikModalUpdateComponent } from '../lookups/osoba/osoba-zna-jezik/osoba-zna-jezik-modal-update.component';
import { StatusRoComponent } from './status-ro/status-ro.component';
import { ResenjeZaPlacenoOdsustvoComponent } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo.component';
import { ResenjeZaPlacenoOdsustvoModalUpdateComponent } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo-modal-update.component';
import { ResenjeZaPlacenoOdsustvo } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo';
import { ResenjeZaPlacenoOdsustvoView } from './resenje-za-placeno-odsustvo/resenje-za-placeno-odsustvo-view';
import { OsnovZaPravoNaGoModalUpdateComponent } from './pravo-na-go/osnov-za-pravo-na-go-modal-update.component';
import { OsnovZaPravoNaGoView } from './pravo-na-go/osnov-za-pravo-na-go-view';
import { OsnovZaPravoNaGo } from './pravo-na-go/osnov-za-pravo-na-go';
import { PravoNaGoView } from './pravo-na-go/pravo-na-go-view';
import { PravoNaGo } from './pravo-na-go/pravo-na-go';
import { PravoNaGoTabsComponent } from './pravo-na-go/pravo-na-go-tabs.component';
import { CanDeactivateGuard } from 'yt-ng-framework';
import { AngazovanjeRoResenjeModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-resenje-modal-update.component';
import { UgovorRo } from './angazovanje-ro/ugovor-ro';
import { UgovorRoView } from './angazovanje-ro/ugovor-ro-view';
import { AngazovanjeRoResenjeUpdateComponent } from './angazovanje-ro/angazovanje-ro-resenje-update.component';
import { AngazovanjeRoAnexUpdateComponent } from './angazovanje-ro/angazovanje-ro-anex-update.component';
import { AngazovanjeRoAnexModalUpdateComponent } from './angazovanje-ro/angazovanje-ro-anex-modal-update.component';
import { TipStrucnogUsavrsavanjaComponent } from './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja.component';
import { TipStrucnogUsavrsavanjaModalUpdateComponent } from './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja-modal-update.component';
import { TipStrucnogUsavrsavanja } from './tip-strucnog-usavrsavanja/tip-strucnog-usavrsavanja';
import { TipPotvrdeOStrucnomUsavrsavanjuComponent } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju.component';
import { TipPotvrdeOStrucnomUsavrsavanju } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju';
import { TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent } from './tip-potvrde-o-strucnom-usavrsavanju/tip-potvrde-o-strucnom-usavrsavanju-modal-update.component';
import { StrucnoUsavrsavanjeComponent } from './strucno-usavrsavanje/strucno-usavrsavanje.component';
import { StrucnoUsavrsavanje } from './strucno-usavrsavanje/strucno-usavrsavanje';
import { StrucnoUsavrsavanjeModalUpdateComponent } from './strucno-usavrsavanje/strucno-usavrsavanje-modal-update.component';
import { ResenjeZaGoComponent } from './resenje-za-go/resenje-za-go.component';
import { ResenjeZaGo } from './resenje-za-go/resenje-za-go';
import { ResenjeZaGoModalUpdateComponent } from './resenje-za-go/resenje-za-go-modal-update.component';
import { StrucnoUsavrsavanjeView } from './strucno-usavrsavanje/strucno-usavrsavanje-view';
import { OsobaRadnaOpremaComponent } from '../lookups/osoba/osoba-radna-oprema/osoba-radna-oprema.component';
import { OsobaSrodstvoComponent } from '../lookups/osoba/osoba-srodstvo/osoba-srodstvo.component';
import { ResenjeZaGoView } from './resenje-za-go/resenje-za-go-view';
import { ResenjeZaGoTabsComponent } from './resenje-za-go/resenje-za-go-tabs.component';
import { DeoZaResenjeZaGoView } from './resenje-za-go/deo-za-resenje-za-go-view';
import { DeoZaResenjeZaGo } from './resenje-za-go/deo-za-resenje-za-go';
import { PregledGoComponent } from './pregled-go/pregled-go.component';
import { PregledGo } from './pregled-go/pregled-go';
import { OrgJed } from '../lookups/orgjed/orgjed';
import { FilterWithZaposlenComponent } from './_filters/filter-with-zaposlen.component';
import { OrgJedComponent } from '../lookups/orgjed/orgjed.component';
import { SistRadnihMestaTabsComponent } from './sist-radnih-mesta/sist-radnih-mesta-tabs.component';
import { AngazovanjeRoResenjeComponent } from './angazovanje-ro/angazovanje-ro-resenje.component';
import { AngazovanjeRoResenjeView } from './angazovanje-ro/angazovanje-ro-resenje-view';
import { AnexRo } from './angazovanje-ro/anex-ro';
import { Zaposleni } from './zaposleni/zaposleni';
// import { ZaposleniComponent } from './zaposleni/zaposleni.component';
import { ZaposleniView } from './zaposleni/zaposleni-view';
import { ZaposleniTabsComponent } from './zaposleni/zaposleni-tabs.component';
// import { ZaposleniUpdateModalComponent } from './zaposleni/zaposleni-update-modal.component';

// import { DefaultListButtonsConfig } from 'dist/yt-ng-framework/lib/base-components/default-list-buttons/default-list-buttons-config';



let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    }

    , {
        path: 'angazovanjero',
        component: AngazovanjeRoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                userRightsModelName : 'angazovanjero',
                modelName: 'ugovorro',
                getName: 'get',
                getParameters: [],
                modelClass: UgovorRo,
                shortModelClass: UgovorRoView,
                parentProperty: '',
                tableColumns: [
                    { name: 'TipDokumenta', label: 'ANGAZOVANJERO.TIPDOKUMENTA.SINGULAR', visible: true }
                    , { name: 'Broj', label: 'ANGAZOVANJERO.BROJ.SINGULAR', visible: true }
                    , { name: 'Datum', label: 'ANGAZOVANJERO.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                    , { name: 'Osoba', label: 'ANGAZOVANJERO.OSOBA.SINGULAR', visible: true }
                    , { name: 'RadnoMesto', label: 'ANGAZOVANJERO.RADNOMESTO.SINGULAR', visible: true }
                    , { name: 'StatusRo', label: 'ANGAZOVANJERO.STATUSRO.SINGULAR', visible:true }
                    , { name: 'OdDatuma', label: 'ANGAZOVANJERO.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                    , { name: 'DoDatuma', label: 'ANGAZOVANJERO.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                    , {
                        name: "Color",
                        label: "ANGAZOVANJERO.COLOR.SINGULAR",
                        type: "color-box",
                        visible: true,
                        canHide: false,
                        width: "33px",
                    }
                ],
                sortBy: 'Broj',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: '',
            updateComponent: AngazovanjeRoModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ANGAZOVANJERO.PLURAL'
        }
    },

    {
        path: 'zaposleni',
        component: ZaposleniTabsComponent,
        pathMatch: 'full',        
        data: {
            mainList: {
                modelName: 'zaposleni',
                userRightsModelName: 'zaposleni',
                getName: 'get',
                shortModelClass: ZaposleniView,
                getParameters: [],
                modelClass: Zaposleni,
                parentProperty: '',
                tableColumns: [
                    { name: 'Ime', label: 'ZAPOSLENI.IME.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'Prezime', label: 'ZAPOSLENI.PREZIME.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Ime',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Zaposleni',
            updateComponent: '',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ZAPOSLENI.PLURAL'
        }
    }
    // , {
    //     path: 'zaposleni',
    //     component: ZaposleniTabsComponent,
    //     pathMatch: 'full',
    //     data: {
    //         mainList: {
    //             modelName: 'zaposleni',
    //             userRightsModelName: 'zaposleni',
    //             getName: 'get',
    //             getParameters: [],
    //             modelClass: Zaposleni,
    //             parentProperty: '',
    //             tableColumns: [
    //                 { name: 'Prezime', label: 'OSOBA.PREZIME.SINGULAR', visible: true }
    //                 , { name: 'Ime', label: 'OSOBA.IME.SINGULAR', visible: true }
    //             ],
    //             sortBy: 'PREZIME',
    //             sortReverse: true,
    //             enableEdit: true,
    //             enableDelete: false,
    //             formType: FormType.Reactive
    //             , shortModelClass: ZaposleniView
    //             // , detailList: [
    //             //     {
    //             //         modelName: 'OsobaEmail',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: OsobaEmail,
    //             //         shortModelClass: OsobaEmailView,
    //             //         tableColumns: [
    //             //             { name: 'Email', label: 'OSOBAEMAIL.NAZIV.SINGULAR', visible: true }
    //             //             , { name: 'Glavni', label: 'OSOBAEMAIL.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean }
    //             //             , { name: 'Svojina', label: 'OSOBAEMAIL.SVOJINA.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'Email',
    //             //         sortReverse: false,
    //             //         enableEdit: false,
    //             //         enableDelete: false,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaEmailModalUpdateComponent,
    //             //         formType: 'reactive',
    //             //         showOnFirstPage: false
    //             //     }
    //             //     , {
    //             //         modelName: 'OsobaTelefon',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],                       
    //             //         modelClass: OsobaTelefon,
    //             //         shortModelClass: OsobaTelefonView,
    //             //         tableColumns: [
    //             //             { name: 'Broj', label: 'OSOBATELEFON.BROJ.SINGULAR', visible: true }
    //             //             , { name: 'VrstaTelefona', label: 'OSOBATELEFON.VRSTATELEFONA.SINGULAR', visible: true }
    //             //             , { name: 'Glavni', label: 'OSOBATELEFON.GLAVNI.SINGULAR', visible: true, type: ColumnType.Boolean }
    //             //             , { name: 'Lokal', label: 'OSOBATELEFON.LOKAL.SINGULAR', visible: true }
    //             //             , { name: 'Svojina', label: 'OSOBATELEFON.SVOJINA.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'Broj',
    //             //         sortReverse: false,
    //             //         enableEdit: false,
    //             //         enableDelete: false,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaTelefonModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             //     , {
    //             //         modelName: 'angazovanjero',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: AngazovanjeRo,
    //             //         shortModelClass: AngazovanjeRoView,
    //             //         tableColumns: [
    //             //             { name: 'TipDokumenta', label: 'ANGAZOVANJERO.TIPDOKUMENTA.SINGULAR', visible: true }
    //             //             , { name: 'Broj', label: 'ANGAZOVANJERO.BROJ.SINGULAR', visible: true }
    //             //             , { name: 'Datum', label: 'ANGAZOVANJERO.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
    //             //             , { name: 'Osoba', label: 'ANGAZOVANJERO.OSOBA.SINGULAR', visible: true }
    //             //             , { name: 'RadnoMesto', label: 'ANGAZOVANJERO.RADNOMESTO.SINGULAR', visible: true }
    //             //             , { name: 'StatusRo', label: 'ANGAZOVANJERO.STATUSRO.SINGULAR', visible:true }
    //             //             , { name: 'OdDatuma', label: 'ANGAZOVANJERO.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
    //             //             , { name: 'DoDatuma', label: 'ANGAZOVANJERO.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
    //             //             , {
    //             //                 name: "Color",
    //             //                 label: "ANGAZOVANJERO.COLOR.SINGULAR",
    //             //                 type: "color-box",
    //             //                 visible: true,
    //             //                 canHide: false,
    //             //                 width: "33px",
    //             //             }
    //             //         ],
    //             //         sortBy: 'Broj',
    //             //         sortReverse: true,
    //             //         enableEdit: true,
    //             //         enableDelete: true,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: AngazovanjeRoModalUpdateComponent,
    //             //         formType: FormType.Reactive,
    //             //         showOnFirstPage: false
    //             //     }
    //             //     , {
    //             //         modelName: 'OsobaZanimanje',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: OsobaZanimanje,
    //             //         shortModelClass: OsobaZanimanjeView,
    //             //         tableColumns: [
    //             //             { name: 'Zanimanje', label: 'OSOBAZANIMANJE.ZANIMANJE.SINGULAR', visible: true }
    //             //             , { name: 'Sprema', label: 'OSOBAZANIMANJE.SPREMA.SINGULAR', visible: true }
    //             //             , { name: 'Skola', label: 'OSOBAZANIMANJE.SKOLA.SINGULAR', visible: true }
    //             //             , { name: 'Zvanje', label: 'OSOBAZANIMANJE.ZVANJE.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'Zvanje',
    //             //         sortReverse: false,
    //             //         enableEdit: false,
    //             //         enableDelete: false,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaZanimanjeModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             //     , {
    //             //         modelName: 'OsobaSrodstvo',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: OsobaSrodstvo,
    //             //         shortModelClass: OsobaSrodstvoView,
    //             //         tableColumns: [
    //             //             { name: 'SrodOsoba', label: 'OSOBASRODSTVO.SRODOSOBA.SINGULAR', visible: true }
    //             //             , { name: 'Srodstvo', label: 'OSOBASRODSTVO.SRODSTVO.SINGULAR', visible: true }
    //             //             , { name: 'Pol', label: 'OSOBASRODSTVO.POL.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'Srodstvo',
    //             //         sortReverse: false,
    //             //         enableEdit: true,
    //             //         enableDelete: false,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaSrodstvoModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             //     , {
    //             //         modelName: 'OsobaRadnaOprema',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: OsobaRadnaOprema,
    //             //         shortModelClass: OsobaRadnaOpremaView,
    //             //         tableColumns: [
    //             //             { name: 'TipRadneOpreme', label: 'OSOBARADNAOPREMA.TIPRADNEOPREME.SINGULAR', visible: true }
    //             //             , { name: 'VelicinaStav', label: 'OSOBARADNAOPREMA.VELICINA.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'TipRadneOpreme',
    //             //         sortReverse: false,
    //             //         enableEdit: true,
    //             //         enableDelete: true,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaRadnaOpremaModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             //     , {
    //             //         modelName: 'OsobaZnaJezik',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: OsobaZnaJezik,
    //             //         shortModelClass: OsobaZnaJezikView,
    //             //         tableColumns: [
    //             //             { name: 'Jezik', label: 'OSOBAZNAJEZIK.JEZIK.SINGULAR', visible: true }
    //             //         ],
    //             //         sortBy: 'Jezik',
    //             //         sortReverse: false,
    //             //         enableEdit: true,
    //             //         enableDelete: true,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: OsobaZnaJezikModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             //     , {
    //             //         modelName: 'strucnousavrsavanje',
    //             //         getName: 'getByOsobaID',
    //             //         getParameters: [],
    //             //         modelClass: StrucnoUsavrsavanje,
    //             //         shortModelClass: StrucnoUsavrsavanjeView,
    //             //         tableColumns: [
    //             //              { name: 'Naziv', label: 'STRUCNOUSAVRSAVANJE.NAZIV.SINGULAR', visible: true, canHide: false }                   
    //             //             ,{ name: 'TipStrucnogUsavrsavanjaNaziv', label: 'STRUCNOUSAVRSAVANJE.TIPSTRUCNOGUSAVRSAVANJA.SINGULAR', visible: true, canHide: false }
    //             //             ,{ name: 'TipPotvrdeOStrucnomUsavrsavanjuNaziv', label: 'STRUCNOUSAVRSAVANJE.TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.SINGULAR', visible: true, canHide: false }
    //             //             ,{ name: 'Trajanje', label: 'STRUCNOUSAVRSAVANJE.TRAJANJE.SINGULAR', visible: true, canHide: false }
    //             //             ,{ name: 'BrojBodova', label: 'STRUCNOUSAVRSAVANJE.BROJBODOVA.SINGULAR', visible: true, canHide: false, type: 'number' }
    //             //         ],
    //             //         sortBy: 'Naziv',
    //             //         sortReverse: false,
    //             //         enableEdit: true,
    //             //         enableDelete: true,
    //             //         parentProperty: 'OsobaID',
    //             //         updateComponent: StrucnoUsavrsavanjeModalUpdateComponent,
    //             //         formType: 'reactive'
    //             //     }
    //             // ]
    //             , closeAfterSave: false
    //         },
    //         mainTitle: 'Zaposleni',
    //         updateComponent: null,
    //         refreshType: RefreshType.NoReload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'ZAPOSLENI.PLURAL'
    //     }
    // }
    , {
        path: 'beneficirani',
        component: BeneficiraniComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'beneficirani',
                getName: 'get',
                getParameters: [],
                modelClass: Beneficirani,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'BENEFICIRANI.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Beneficirani',
            updateComponent: BeneficiraniModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'BENEFICIRANI.SINGULAR'
        }
    }
    , {
        path: 'verskipraznik',
        component: VerskiPraznikComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'verskipraznik',
                getName: 'get',
                getParameters: [],
                modelClass: VerskiPraznik,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VERSKIPRAZNIK.NAZIV.SINGULAR', visible: true }
                    , { name: 'Dan', label: 'VERSKIPRAZNIK.DAN.SINGULAR', visible: true }
                    , { name: 'Mesec', label: 'VERSKIPRAZNIK.MESEC.SINGULAR', visible: true }
                    , { name: 'Godina', label: 'VERSKIPRAZNIK.GODINA.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Verski praznik',
            updateComponent: VerskiPraznikModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VERSKIPRAZNIK.PLURAL'
        }
    }
    // , {
    //     path: 'srodstvo',
    //     component: SrodstvoComponent,
    //     pathMatch: 'full',
    //     data: {
    //         mainList: {
    //             modelName: 'srodstvo',
    //             getName: 'get',
    //             getParameters: [],
    //             modelClass: Srodstvo,
    //             parentProperty: '',
    //             tableColumns: [
    //                 { name: 'Naziv', label: 'SRODSTVO.NAZIV.SINGULAR', visible: true}
    //             ],
    //             sortBy: 'Naziv',
    //             sortReverse: true,
    //             enableEdit: true,
    //             enableDelete: true,
    //             formType: FormType.Reactive
    //         },
    //         mainTitle: 'Srodstvo',
    //         updateComponent: SrodstvoModalUpdateComponent,
    //         modalSize: ModalSize.Md,
    //         refreshType: RefreshType.NoReload,
    //         loadOnInit: true,
    //         breadcrumbLabel: 'SRODSTVO.SINGULAR'
    //     }
    // }
    , {
        path: 'razlogprestankaro',
        component: RazlogPrestankaRoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'razlogprestankaro',
                getName: 'get',
                getParameters: [],
                modelClass: RazlogPrestankaRo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'RAZLOGPRESTANKARO.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Razlog prestanka radnog odnosa',
            updateComponent: RazlogPrestankaRoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'RAZLOGPRESTANKARO.PLURAL'
        }
    }
    , {
        path: 'osnovzago',
        component: OsnovZaGoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'osnovzago',
                getName: 'get',
                getParameters: [],
                modelClass: OsnovZaGo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'OSNOVZAGO.NAZIV.SINGULAR', visible: true}
                    , { name: 'GenericName', label: 'OSNOVZAGO.GenericName.SINGULAR', visible: false}
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,     
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'osnov-za-go',
            updateComponent: OsnovZaGoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSNOVZAGO.PLURAL'
        }
    }
    , {
        path: 'osnovzaplacenoodsustvo',
        component: OsnovZaPlacenoOdsustvoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'osnovzaplacenoodsustvo',
                getName: 'get',
                getParameters: [],
                modelClass: OsnovZaPlacenoOdsustvo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'OSNOVZAPLACENOODSUSTVO.NAZIV.SINGULAR', visible: true }
                    , { name: 'min_broj_dana', label: 'OSNOVZAPLACENOODSUSTVO.MIN_BROJ_DANA.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'osnov-za-placeno-odsustvo',
            updateComponent: OsnovZaPlacenoOdsustvoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSNOVZAPLACENOODSUSTVO.PLURAL'
        }
    }
    , {
        path: 'veroispovest',
        component: VeroispovestComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'veroispovest',
                getName: 'get',
                getParameters: [],
                modelClass: Veroispovest,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'VEROISPOVEST.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'veroispovest',
            updateComponent: VeroispovestModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'VEROISPOVEST.PLURAL'
        }
    }
    , {
        path: 'jezik',
        component: JezikComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'jezik',
                getName: 'get',
                getParameters: [],
                modelClass: Jezik,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'JEZIK.NAZIV.SINGULAR', visible: true }
                ],
                sortBy: 'Naziv',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'jezik',
            updateComponent: JezikModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'JEZIK.PLURAL'
        }
    }
    , {
        path: 'radna-knjizica',
        component: RadnaKnjizicaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'radnaknjizica',
                getName: 'get',
                getParameters: [],
                modelClass: RadnaKnjizica,
                shortModelClass: RadnaKnjizicaView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Osoba', label: 'RADNAKNJIZICA.OSOBA.SINGULAR' },
                    { name: 'OdDatuma', label: 'RADNAKNJIZICA.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy' },
                    { name: 'DoDatuma', label: 'RADNAKNJIZICA.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy' },
                    { name: 'NazivISedistePoslodavca', label: 'RADNAKNJIZICA.NAZIVISEDISTEPOSLODAVCA.SINGULAR' },
                    { name: 'Staz', label: 'RADNAKNJIZICA.STAZ.SINGULAR' }
                ],
                sortBy: 'Osoba',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: '',
            updateComponent: RadnaKnjizicaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'RADNAKNJIZICA.PLURAL'
        }
    },
    {
        path: 'sist-radnih-mesta',
        component: SistRadnihMestaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                // defaultListButtonsConfig: {
                //     AddButtonConfig: {
                //         Visible: false
                //     } 
                //     , DeleteButtonConfig: {
                //         Visible: false
                //     }
                //     , SaveButtonConfig: {
                //         Visible: false
                //     }
                //     , ResetButtonConfig: {
                //         Visible: false
                //     }
                // },
                modelName: 'orgjed',
                getName: 'getParentAndChildByParentID',
                getParameters: [],
                modelClass: OrgJed,
                // shortModelClass: OrgJedView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'ORGJED.NAZIV.SINGULAR', visible: true, canHide: false}
                ],
                sortBy: 'OrgJed',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                defaultListType: DefaultListType.Treeview,
                detailList: [
                    {
                        modelName: 'SistRadnihMesta',
                        getName: 'getByOrgJedID',
                        getParameters: [],
                        modelClass: SistRadnihMesta,
                        shortModelClass: SistRadnihMestaView,
                        tableColumns: [
                            { name: 'RadnoMesto', label: 'SISTRADNIHMESTA.RADNOMESTO.SINGULAR' },
                            { name: 'BrojIzvrsilaca', label: 'SISTRADNIHMESTA.BROJIZVRSILACA.SINGULAR', type: 'number', format: '1.0-0' }                        ],
                        sortBy: 'RadnoMesto',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'OrgJedID',
                        updateComponent: '',
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ],

            },
            mainTitle: 'Sistematizacija radnih mesta',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'SISTRADNIHMESTA.SINGULAR'
        }
    },
    {
        path: 'statusro',
        component: StatusRoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'StatusRo',
                userRightsModelName: 'statusradnogodnosa',
                getName: 'get',
                getParameters: [],
                modelClass: StatusRo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'STATUSRO.NAZIV.SINGULAR' }

                ],
                sortBy: 'BrIzvrsilaca',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: '',
            updateComponent: StatusRoModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'STATUSRO.PLURAL'
        }
    },
    
    {
        path: 'radnovreme',
        component: RadnoVremeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'radnovreme',
                getName: 'get',
                getParameters: [],
                modelClass: RadnoVreme,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'RADNOVREME.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Radno vreme',
            updateComponent: RadnoVremeModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'RADNOVREME.PLURAL'
        }
    }
    , {
        path: 'resenjezaplacenoodsustvo',
        component: ResenjeZaPlacenoOdsustvoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                // printName: 'printaj',
                printName: 'stampa_resenja_za_placeno_odsustvo',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'resenjezaplacenoodsustvo',
                userRightsModelName: 'resenjezaplacenoodsustvo',
                getName: 'get',
                getParameters: [{ Name: 'url', Value: '/kad/resenjezaplacenoodsustvo' }],
                modelClass: ResenjeZaPlacenoOdsustvo,
                shortModelClass: ResenjeZaPlacenoOdsustvoView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Osoba', label: 'RESENJEZAPLACENOODSUSTVO.OSOBA.SINGULAR', visible: true },
                    { name: 'Osnov', label: 'RESENJEZAPLACENOODSUSTVO.OSNOV.SINGULAR', visible: true },
                    { name: 'BrojDokumenta', label: 'RESENJEZAPLACENOODSUSTVO.BROJ.SINGULAR', visible: true },
                    { name: 'Datum', label: 'RESENJEZAPLACENOODSUSTVO.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true },
                    { name: 'OdDatuma', label: 'RESENJEZAPLACENOODSUSTVO.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true },
                    { name: 'DoDatuma', label: 'RESENJEZAPLACENOODSUSTVO.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true },
                    { name: 'Dana', label: 'RESENJEZAPLACENOODSUSTVO.DANA.SINGULAR', visible: true },
                    { name: 'DatumPocetkaRada', label: 'RESENJEZAPLACENOODSUSTVO.DATUMPOCETKARADA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy' },
                    { name: 'Napomena', label: 'RESENJEZAPLACENOODSUSTVO.NAPOMENA.SINGULAR', visible: true }
                ],
                sortBy: 'Osoba',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: '',
            updateComponent: ResenjeZaPlacenoOdsustvoModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'RESENJEZAPLACENOODSUSTVO.PLURAL'
        }
    }

    , {
        path: 'pravonago',
        component: PravoNaGoTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                // printName: 'printaj',
                modelName: 'pravonago',
                getName: 'get',
                getParameters: [],
                modelClass: PravoNaGo,
                shortModelClass: PravoNaGoView,
                parentProperty: '',
                tableColumns: [
                    { name: 'Osoba', label: 'PRAVONAGO.OSOBA.SINGULAR', visible: true }
                   ,{ name: 'Godina', label: 'PRAVONAGO.GODINA.SINGULAR', type: 'text', aligment: 'right' }
                ],
                sortBy: 'Osoba',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: false,
                // formType: 'reactive',
                formType: FormType.Reactive,                
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'osnovzapravonago',
                        getName: 'getByPravoNaGoID',
                        getParameters: [],
                        modelClass: OsnovZaPravoNaGo,
                        shortModelClass: OsnovZaPravoNaGoView,
                        tableColumns: [
                            { name: 'OsnovZaGo', label: 'OSNOVZAPRAVONAGO.OSNOVZAGO.SINGULAR', visible: true }
                           ,{ name: 'BrojDana', label: 'OSNOVZAPRAVONAGO.BROJDANA.SINGULAR', type: 'text', aligment: 'right' }
                        ],
                        sortBy: 'OsnovZaGo',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'PravoNaGoID',
                        updateComponent: OsnovZaPravoNaGoModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ]
            },
            //detailList: [],
            mainTitle: 'Pravo na godišnji odmor',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'PRAVONAGO.SINGULAR'
        }
    }

    , {
        path: 'resenjezago',
        //component: ResenjeZaGoComponent,
        component: ResenjeZaGoTabsComponent,
        canDeactivate: [CanDeactivateGuard],
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'stampa_resenja_za_go',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'resenjezago',
                getName: 'get',
                getParameters: [],                
                modelClass: ResenjeZaGo,
                shortModelClass: ResenjeZaGoView,
                parentProperty: '',
                tableColumns: [
                     { name: 'Osoba', label: 'RESENJEZAGO.OSOBA.SINGULAR', visible: true }
                    ,{ name: 'Datum', label: 'RESENJEZAGO.DATUM.SINGULAR' , type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                    ,{ name: 'Broj', label: 'RESENJEZAGO.BROJ.SINGULAR', visible: true }
                    ,{ name: 'PravoNaGoBrojDana', label: 'RESENJEZAGO.PRAVONAGOBROJDANA.SINGULAR', visible: true }
                ],
                sortBy: 'OsobaPrezimeIIme',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'DeoZaResenjeZaGo',
                        getName: 'getByResenjeZaGoID',
                        getParameters: [],
                        modelClass: DeoZaResenjeZaGo,
                        shortModelClass: DeoZaResenjeZaGoView,
                        tableColumns: [
                            { name: 'OdDatuma', label: 'DEOZARESENJEZAGO.ODDATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                            , { name: 'DoDatuma', label: 'DEOZARESENJEZAGO.DODATUMA.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'ResenjeZaGoID',
                        updateComponent: '',
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ],
            },
            mainTitle: '',
            updateComponent: null,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'RESENJEZAGO.PLURAL'
        }
    }
    , {
        path: 'angazovanjeroresenje',
        component: AngazovanjeRoResenjeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'printaj',
                modelName: 'AngazovanjeRoResenje',
                userRightsModelName : 'angazovanjeroresenje',
                getName: 'get',
                getParameters: [],
                modelClass: AngazovanjeRoResenje,
                shortModelClass: AngazovanjeRoResenjeView,
                parentProperty: '',
                tableColumns: [
                    { name: 'TipDokumenta', label: 'ANGAZOVANJERO.TIPDOKUMENTA.SINGULAR', visible: true }
                    , { name: 'Broj', label: 'ANGAZOVANJERO.BROJ.SINGULAR', visible: true }
                    , { name: 'Datum', label: 'ANGAZOVANJERO.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                    , { name: 'Osoba', label: 'ANGAZOVANJERO.OSOBA.SINGULAR', visible: true }                    
                ],
                sortBy: '',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                ],
                defaultPropertyName: 'Broj'
            },
            mainTitle: 'Rešenje za raskid',
            updateComponent: AngazovanjeRoResenjeModalUpdateComponent,
            refreshType: RefreshType.NoReload,
            modalSize: ModalSize.Lg,
            loadOnInit: true,
            breadcrumbLabel: 'MENI.RESENJEORASKIDUUGOVORA.PLURAL'
        }
    }

    , {
        path: 'angazovanjeroanex',
        component: AngazovanjeRoAnexUpdateComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                modelName: 'angazovanjeroanex',
                getName: 'get',
                getParameters: [],
                modelClass: AnexRo,
                shortModelClass: AngazovanjeRoView,
                parentProperty: '',
                tableColumns: [
                ],
                sortBy: '',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                enablePrint: true,
                formType: FormType.Reactive,
                closeAfterSave: false,
                detailList: [
                ],
                defaultPropertyName: 'Broj'
            },
            mainTitle: 'Anex ugovora o radu',
            updateComponent: AngazovanjeRoAnexModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'ANGAZOVANJERO.ANEKS.PLURAL'
        }
    }
    ,
    {
        path: 'tipstrucnogusavrsavanja',
        component: TipStrucnogUsavrsavanjaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'tipstrucnogusavrsavanja',
                userRightsModelName: 'tipstrucnogusavrsavanja',
                getName: 'get',
                getParameters: [],
                modelClass: TipStrucnogUsavrsavanja,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'TIPSTRUCNOGUSAVRSAVANJA.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Tip stručnog usavršavanja',
            updateComponent: TipStrucnogUsavrsavanjaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TIPSTRUCNOGUSAVRSAVANJA.PLURAL'
        }
    }
    ,
    {
        path: 'tippotvrdeostrucnomusavrsavanju',
        component: TipPotvrdeOStrucnomUsavrsavanjuComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                showCheckBoxes: false, 
                modelName: 'tippotvrdeostrucnomusavrsavanju',
                userRightsModelName: 'tippotvrdeostrucnomusavrsavanju',
                getName: 'get',
                getParameters: [],
                modelClass: TipPotvrdeOStrucnomUsavrsavanju,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.NAZIV.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Tip potvrde o stručnom usavršavanju',
            updateComponent: TipPotvrdeOStrucnomUsavrsavanjuModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.PLURAL'
        }
    }
    ,
    {
        path: 'strucnousavrsavanje',
        component: StrucnoUsavrsavanjeComponent,
        pathMatch: 'full',        
        data: {
            mainList: {
                modelName: 'strucnousavrsavanje',
                userRightsModelName: 'strucnousavrsavanje',
                getName: 'get',
                shortModelClass: StrucnoUsavrsavanjeView,
                getParameters: [],
                modelClass: StrucnoUsavrsavanje,
                parentProperty: '',
                tableColumns: [
                    { name: 'Naziv', label: 'STRUCNOUSAVRSAVANJE.NAZIV.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'OsobaPrezimeIIme', label: 'STRUCNOUSAVRSAVANJE.OSOBA.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'TipStrucnogUsavrsavanjaNaziv', label: 'STRUCNOUSAVRSAVANJE.TIPSTRUCNOGUSAVRSAVANJA.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'TipPotvrdeOStrucnomUsavrsavanjuNaziv', label: 'STRUCNOUSAVRSAVANJE.TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'Trajanje', label: 'STRUCNOUSAVRSAVANJE.TRAJANJE.SINGULAR', visible: true, canHide: false }
                   ,{ name: 'BrojBodova', label: 'STRUCNOUSAVRSAVANJE.BROJBODOVA.SINGULAR', visible: true, canHide: false, type: 'number' }

                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'Stručno usavršavanje',
            updateComponent: StrucnoUsavrsavanjeModalUpdateComponent,
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'STRUCNOUSAVRSAVANJE.PLURAL'
        }
    }
    ,{
        path: 'radnaoprema',
        component: OsobaRadnaOpremaComponent,
        pathMatch: 'full',        
        data: {
            mainList: {
                modelName: 'osobaradnaoprema',
                userRightsModelName: 'radnaoprema',
                getName: 'get',
                shortModelClass: OsobaRadnaOpremaView,
                getParameters: [],
                modelClass: OsobaRadnaOprema,
                parentProperty: '',
                tableColumns: [
                    { name: 'Osoba', label: 'OSOBARADNAOPREMA.OSOBA.SINGULAR', visible: true, canHide: false }
                    , { name: 'TipRadneOpreme', label: 'OSOBARADNAOPREMA.TIPRADNEOPREME.SINGULAR', visible: true }
                    , { name: 'VelicinaStav', label: 'OSOBARADNAOPREMA.VELICINA.SINGULAR', visible: true }

                ],
                sortBy: 'Osoba',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                formControlDataName: 'kad/radnaoprema',
                defaultListFilterComponent: FilterWithZaposlenComponent,
                requestType: RequestType.POST
            },
            mainTitle: 'Osoba radna oprema',
            updateComponent: OsobaRadnaOpremaModalUpdateComponent,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'OSOBARADNAOPREMA.PLURAL'
        }
    }
    , {
        path: 'pregledgodisnjihodmora',
        component: PregledGoComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'stampa_pregledago',
                printType: PrintType.List,
                printController: 'Report',
                modelName: 'pregledgo',
                userRightsModelName: 'pregledgodisnjihodmora',
                getName: 'GetByPeriod',
                getParameters: [],
                modelClass: PregledGo,
                parentProperty: '',
                tableColumns: [
                    { name: 'Osoba', label: 'PREGLEDGO.OSOBA.SINGULAR', visible: true, canHide: false }
                    , { name: 'StariPravoDana', label: 'PREGLEDGO.STARIPRAVODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'StariIskoristenoDana', label: 'PREGLEDGO.STARIISKORISTENODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'StariPropaloDana', label: 'PREGLEDGO.STARIPROPALODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'StariOstaloDana', label: 'PREGLEDGO.STARIOSTALODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'NoviPravoDana', label: 'PREGLEDGO.NOVIPRAVODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'NoviIskoristenoDana', label: 'PREGLEDGO.NOVIISKORISTENODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'NoviOstaloDana', label: 'PREGLEDGO.NOVIOSTALODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'OstaloDana', label: 'PREGLEDGO.OSTALODANA.SINGULAR', visible: true, canHide: false, type: 'number' }
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'ID',
                enablePrint: false
            },
            mainTitle: 'Pregled G.O. ',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'PREGLEDGO.SINGULAR'
        }
    }

 
    
];

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: KadComponent,
        children: childrenRoutes
    }
]
@NgModule(
    {
        imports: [RouterModule.forChild(routes)],
        exports: [RouterModule]
    }
)
export class KadRoutingModule { }
